import React, { useEffect, useState } from "react";
import { Card, Row, Typography, Col, Divider , Input,Button,Select} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import EmployeeService from "../../services/EmployeeService";
import { useSelector } from "react-redux";
import MenuService from "../../services/MenuService";
import Spinner from "../../components/Layout/Spinner";

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

export default function IssueDetails({ order, setShowDetails,isEdit,updateIssues }) {

    const adminRestaurant = useSelector((state) => state.admin);
    const [isLoading, setLoading] = useState(isEdit);
    const [issueName,setIssueName] = useState()
    const [issueDescription, setIssueDesc] = useState()
    const [solution, setSolution] = useState("");
    const [employees, setEmployees] = useState([]);
    const [manager, setManager] = useState([]);
    const [menus, setMenus] = useState([]);
    const [selectedManager, setSelectedManager] = useState({});
    const [selectedServer, setSelectedServer] = useState({});
    const [selectedMenu, setSelectedMenu] = useState([]);

        useEffect(()=>{
            if(isEdit){
            setIssueName(order?.order_issue?.issue);
            setIssueDesc(order?.order_issue?.description);
            setSolution(order?.order_issue?.solution);
            setSelectedMenu(order?.menu_items.map((it)=>({label:it.menu_item_name, value:it.menu_item_id})))
            setSelectedServer({
                name: order?.server?.name,
                code: order?.order_issue?.server_code,
                id: order?.order_issue?.server_id,
            })
            setSelectedManager({
                name: order?.manager?.name,
                code: order?.order_issue?.manager_code,
                id: order?.order_issue?.server_id,
            })
            getEmployees()
            }
        },[])

        const getEmployees = async() =>{
            const data = await EmployeeService.getEmployeesByEmployeeType("MANAGER");
            const dataServer = await EmployeeService.getEmployeesByEmployeeType("SERVER");
            setEmployees(dataServer.employees);
            setManager(data.employees)
            const menuItems = await MenuService.getAllMenuItems()
            setMenus(menuItems.menu_items);
            setLoading(false);
        }

        const onNameChange = (e,type) => {
            if(type === "issue")
            setIssueName(e.target.value);
            else
            setIssueDesc(e.target.value)

        };

        const updateIssue =()=>{
            const payload = {
                menu_item_ids: selectedMenu.map((men_it)=>men_it.value),
                issue: issueName,
                server_code: selectedServer?.code,
                server_id: selectedServer?.id,
                manager_code: selectedManager.code,
                manager_id: selectedManager?.id,
                solution,
                description: issueDescription,
                discount_code: order?.order_issue?.discount_code,
                order_id: order?.order_issue?.order_id
            }
            updateIssues(order?.order_issue?.id,payload)
        }

        const handleChangeManager = ( value, data) => {
            const filterByRes = data?.data?.restaurant_roles.find(
              (item) => item.restaurant_id === adminRestaurant
            );
        
            setSelectedManager({
              name: value,
              code: filterByRes?.employee_code,
              id: data?.data?.id,
            });
        }

        const handleChangeServer = ( value, data) => {
            const filterByRes = data?.data?.restaurant_roles.find(
              (item) => item.restaurant_id === adminRestaurant
            );
        
            setSelectedServer({
              name: value,
              code: filterByRes?.employee_code,
              id: data?.data?.id,
            });
        }

        const handleChangeMenu = ( value, data) => {
            setSelectedMenu(data);
        }
        const listallMenuItem = (listItem) => {
          const allMenuItem = listItem?.map((mItem)=>mItem.menu_item_name);
         return allMenuItem.join(', ');
        }

    return (
        <div>
            <div className="catering-header">
                <Title level={4} style={{ cursor: "pointer" }}
                    onClick={() => setShowDetails(false)}> <ArrowLeftOutlined /> Issues</Title>
            </div>

            <div style={{ marginTop: 40 }}>
                <Card bordered={false} className="card-order-container" onClick={() => {

                }}>
                    <div className="cat-each-section">
                        <div className="cat-section-title">TABLE DETAILS</div>
                        <Row className="row-cat-section">
                            <Col>
                                <div className="cat-details-name">
                                    <div className="cat-title">Table:</div>
                                    <div className="cat-name">{order?.table?.table_number}</div>
                                </div>
                            </Col>
                            <Col>
                              <div className="cat-details-name">
                                    <div className="cat-title">Server:</div>
                                    {isEdit?
                                     <Select
                                     value={selectedServer.name}
                                     className="w-full issue-desc-edit"
                                     placeholder={"Server Name"}
                                     onChange={(v, event) => handleChangeServer( v, event)}
                                   >
                                     {employees &&
                                       employees.map((val, index) => {
                                         return (
                                           <Option data={val} key={val.id} value={val.id}>
                                             {val.name}
                                           </Option>
                                         );
                                       })}
                                   </Select>:
                                    <div className="cat-name">{order?.server?.name}</div>}
                                </div>
                            </Col>
                            <Col>
                                <div className="cat-details-name">
                                    <div className="cat-title">Manager:</div>
                                    {isEdit? 
                                     <Select
                                     value={selectedManager.name}
                                     className="w-full issue-desc-edit"
                                     placeholder={"Manager Name"}
                                     onChange={(v, event) => handleChangeManager( v, event)}
                                   >
                                     {manager &&
                                       manager.map((val, index) => {
                                         return (
                                           <Option data={val} key={val.id} value={val.id}>
                                             {val.name}
                                           </Option>
                                         );
                                       })}
                                   </Select>
                                   :
                                    <div className="cat-name">{order?.manager?.name}</div>}
                                </div>
                              </Col>

                        </Row>
                    </div>
                    <Divider />

                    
                    <div className="cat-each-section">
                        <div className="cat-section-title">ISSUE</div>
                        <Row className="row-cat-section">
                            <Col>
                                <div className="cat-details-name">
                                    <div className="cat-title">Item:</div>
                                    {isEdit? 
                                     <Select
                                     mode="multiple"
                                     value={selectedMenu?.map((itm)=>itm.value)}
                                     className="w-full issue-desc-edit"
                                     placeholder={"Menu Name"}
                                     onChange={(v, event) => handleChangeMenu( v, event)}
                                     options={ menus.map((val, index) => ({label:val.name, value:val.id}))}
                                   >
                                     {menus &&
                                       menus.map((val, index) => {
                                         return (
                                           <Option data={val} key={val.id} value={val.id}>
                                             {val.name}
                                           </Option>
                                         );
                                       })}
                                   </Select>
                                   :
                                    <div className="cat-name">{listallMenuItem(order?.menu_items)}</div>}
                                </div>
                                <div className="cat-details-name">
                                    <div className="cat-title">Issue:</div>
                                    {isEdit?
                                    <Input className="cat-name issue-desc-edit" placeholder="Enter Type Name" value={issueName} name="name" onChange={(e)=> onNameChange(e,"issue")}/>
                                    :
                                    <div className="cat-name">{order?.order_issue?.issue}</div>}
                                </div>
                            </Col>
                            <Col>
                                <div className="cat-details-name" style={{alignItems: "baseline"}}>
                                    <div className="cat-title">Note:</div>
                                    {isEdit?
                                     <TextArea className="cat-name issue-desc-edit" rows={3} cols={35} placeholder="Type Description here" name="description"  value={issueDescription}  onChange={(e)=>{onNameChange(e,"desc")}}/>:
                                     
                                    <div className="cat-name">{order?.order_issue?.description}</div>}
                                </div>
                            </Col>

                        </Row>
                    </div>
                    <Divider />

                    <div className="cat-each-section">
                        <div className="cat-section-title">Solution</div>
                        <Row className="row-cat-section">
                            <Col>
                                <div className="cat-details-name">
                                    {/* <div className="cat-title"></div> */}
                                    {isEdit?
                                     <TextArea className="cat-name issue-desc-edi" rows={3} cols={35} placeholder="Type Solution here" name="description"   value={solution} onChange={(e)=> setSolution(e.target.value)} />:
                                    <div className="cat-name">{order?.order_issue?.solution}</div>}
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Divider />
                </Card>

                {isEdit && 
                <div className="update-issue-btn">
                 <Button
                    type="primary"
                    // ghost
                    style={{
                      display: "block",
                      width: 180,
                      marginTop: 20,
                    }}
                    onClick={()=>updateIssue()}
                  >
                    Update Issue
                  </Button> 
                  </div>}
            </div>
            {isLoading && <Spinner/>}
        </div>
    );
}
